import { render } from "./AddChecklist.vue?vue&type=template&id=4918d5a4"
import script from "./AddChecklist.vue?vue&type=script&lang=js"
export * from "./AddChecklist.vue?vue&type=script&lang=js"
script.render = render

export default script